import Channel from "./ChannelHandler";

export class MessengerHub {
  protected up: any;
  protected down: any;
  protected curriers: any;
  protected channels: Channel[];
  protected defaultChannel: Channel;

  constructor() {
    this.up = {};
    this.down = {};
    this.curriers = {};
    this.channels = [];
    this.defaultChannel = new Channel();
    this.defaultChannel.onRegister(this);

    // return new Proxy(this, {
    //     // get:if(this[])
    // });
  }

  // add a new channel middleware
  addChannel(channel: Channel) {
    this.channels.push(channel);
    channel.onRegister(this);
  }

  // registers a new currier
  registerCurrier(currier) {
    this.curriers[currier.getName()] = currier;
    currier.onRegister(this);
  }

  // primary function for sending a message
  send(channel, rawMessage, withResponse = null) {
    // look for channel middleware
    const channelHandler = this.findChannelHandler(channel);

    // let the channel sort out how the curriers do things
    channelHandler.sendMessage(
      channel,
      rawMessage,
      this.curriers,
      withResponse
    );
  }

  getCurriers() {
    return this.curriers;
  }

  // finds the channel handler for a specific channel
  findChannelHandler(channelName: string) {
    // start with the default
    let channelHandler = this.defaultChannel;

    // see if we need any others
    // we use functions instead of a map so that one handler can grab multiple channels
    Object.keys(this.channels).forEach((index) => {
      if (this.channels[index].handlesChannel(channelName)) {
        channelHandler = this.channels[index];
      }
    });

    return channelHandler;
  }

  // this is where curriers deliver messages
  onMessageReceived(message, currier) {
    if (!message || !message.channel) return;
    const channelHandler = this.findChannelHandler(message.channel);

    channelHandler.onMessageReceived(message, currier);
  }

  // subscribes to a channel
  // returns a function to unsubscribe
  subscribe(channel, messageHandler) {
    const channelHandler = this.findChannelHandler(channel);

    return channelHandler.onSubscribe(channel, messageHandler);
  }
}

export default MessengerHub;
